<template>
<section>
  <b-form-row class='my-2'>
    <b-input-group>
      <b-input-group-prepend is-text>
        <span class='mr-2'>{{label}}</span>
        <section v-if=fbIcon style='height:18px;'><i class='fb-icon'></i>&nbsp;</section>
        <section v-if=waIcon style='height:18px;'><i class='wa-icon'></i>&nbsp;</section>
        <section v-if=vtexIcon style='height:20px;'><i class='vtex-icon'></i></section>
        <section v-if=shopifyIcon style='height:20px;'><i class='shopify-icon'></i></section>
        <section v-if=draftIcon style='height:20px;'><i class='draft-icon'></i></section>
      </b-input-group-prepend>
      <b-form-input type=text @input=onInput v-model=content autocomplete=off data-lpignore=true />
    </b-input-group>
  </b-form-row>
</section>
</template>

<script>
export default {
  props: {
    label: { type: String, default: '' },
    fbIcon: { type: Boolean, default: false },
    waIcon: { type: Boolean, default: false },
    vtexIcon: { type: Boolean, default: false },
    shopifyIcon: { type: Boolean, default: false },
    draftIcon: { type: Boolean, default: false },
    value: { required: true },
  },
  data() {
    return {
      content: this.value,
    };
  },
  methods: {
    onInput(e) {
      this.$emit('input', e);
    },
  },
}
</script>

<style scoped>
.input-group-text {
  min-width: 280px;
}
@media (max-width: 576px) {
  .input-group-prepend {
    flex: 1 1 auto;
  }
  .input-group-text {
    flex: 1 1 auto;
  }
}
.boxed {
  background-color: #e9ecef;
  border: 1px solid #ced4da;
  border-radius: 0.25rem 0px 0px 0.25rem
}
input {
  min-width: 200px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/utility/OrderFormInput.vue